import React, { Component } from 'react'
import { Modal } from 'antd'
import BookingForm from '../../../../components/Operations/Transport/InService/BookingForm'

class VehicleModal extends Component {
  render() {
    const { visibleBooking, onCancelBooking, updatingBooking, bookingFormRef, onEditBooking } = this.props
    return (
      <Modal
        width={'75%'}
        visible={visibleBooking}
        title={'Edit Booking'}
        onCancel={onCancelBooking}
        destroyOnClose={true}
        okText={'Update'}
        onOk={onEditBooking}
        confirmLoading={updatingBooking}>
        <BookingForm {...this.props} ref={bookingFormRef} />
      </Modal>
    )
  }
}

VehicleModal.propTypes = {}
VehicleModal.defaultProps = {}

export default VehicleModal
